<div class="holder" #holder>
<svg viewBox="0 0 100 100" [ngClass]="animate" (click)="doAanimate()">
  <g>
    <path id="lane" d="M 50 09 A 41 41 0 0 1 50 91    41 41 0 0 1 50 09" />
    <path id="ring1" d="M 50 09 A 41 41 0 0 1 50 91    41 41 0 0 1 50 09" />
  </g>
</svg>
<div class="value">{{_value}}</div>
<div class="total">{{_total}}</div>
</div>
